import {fetchTBSAdvConf} from "./adv"

class CoralAdv {
    constructor(container, opt = {
        debug: false,
        appId: 0,
        type: 0,
        target: 6,
        handleAdErrorName: '',
        handleAdEventName: '',
        advShowCb: null,
        advClickCb: null,
        advCloseCb: null,
        advErrorCb: null,
    }) {
        this.container = container;
        let coralJs = document.getElementById("coral_js");
        this.appId = coralJs.getAttribute("appid") || opt.appId;
        this.env = coralJs.getAttribute("env");
        this.type = opt.type;
        this.target = opt.target || 6;
        this.handleAdErrorName = opt.handleAdErrorName || 'handleAdError';
        this.handleAdEventName = opt.handleAdEventName || 'handleAdEvent';
        this.advShowCb = opt.advShowCb;
        this.advClickCb = opt.advClickCb;
        this.advCloseCb = opt.advCloseCb;
        this.advErrorCb = opt.advErrorCb;


        this.initCb();
        this.init();
    }

    async init() {
        console.log("init");

        //拉取广告配置
        let advConf = await fetchTBSAdvConf(this.appId, this.type, this.target);
        if(advConf && advConf.position_id){
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://tbsad.imtt.qq.com/tbs/jssdk/js/formal/TBSJSSDK.js?rand='+Math.random();
            //script.setAttribute("posid","100329");
            script.setAttribute("adkey", advConf.position_id);
            script.setAttribute("onAdError", this.handleAdErrorName);
            script.setAttribute("onAdEvent", this.handleAdEventName);
            document.getElementById(this.container).appendChild(script);
        }
    }

    initCb() {
        let _this = this;
        console.log("initCb");

        window[this.handleAdErrorName] = function(errorno) {
            _this.advErrorCb(errorno);
        };
        window[this.handleAdEventName] = function() {
            const evt = arguments[0];
            if (evt === 'CLICK') {
                _this.advClickCb();
            } else if (evt === 'CLOSE') {
                _this.advCloseCb();
            } else if (evt === 'SHOW') {
                _this.advShowCb();
            }
        }
    }
}

export default CoralAdv;
